import { render, staticRenderFns } from "./green-content.html?vue&type=template&id=688d8e8f&scoped=true&"
import script from "./green-content.js?vue&type=script&lang=js&"
export * from "./green-content.js?vue&type=script&lang=js&"
import style0 from "./green-content.scss?vue&type=style&index=0&id=688d8e8f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688d8e8f",
  null
  
)

export default component.exports